import { ValidationRuleSchema } from "vee-validate/dist/types/types";
import IPasswordOptions from "../IPasswordOptions";

/**
 * Validates a password. See http://vee-validate.logaretm.com/v2/guide/custom-rules.html#creating-a-custom-rule
 *
 * @export
 * @implements {ValidationRuleSchema}
 */
const password: ValidationRuleSchema = {
    params: ["regex", "options"],

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    validate(value: string, { regex, options }: any): boolean {
        const regExp = new RegExp(regex);
        return regExp.test(value);
    },

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    message(field: string, { options }: any): string {
        return getPasswordMessage(options);
    }
};

export default password;

/**
 * Creates a validation message from the given options
 *
 * @param {IPasswordOptions} options
 * @returns {string}
 */
function getPasswordMessage(options: IPasswordOptions): string {
    let message = `Password must be at least ${options.requiredLength} characters`;

    if (options.requireDigit) {
        message += ", have one number";
    }

    if (options.requireLowercase) {
        message += ", one lowercase letter";
    }

    if (options.requireUppercase) {
        message += ", one uppercase letter";
    }

    if (options.requireNonAlphanumeric) {
        message += ", one special character (e.g. !@#$%)";
    }

    message += ".";

    return message;
}
